import { useTranslation } from 'react-i18next';
import type { PaginationMeta } from '@/types';

interface PaginationProps {
  meta: PaginationMeta | undefined;
  onPageChange: (page: number) => void;
}

export default function Pagination({ meta, onPageChange }: PaginationProps) {
  const { t } = useTranslation();
  if (!meta || meta.pages <= 1) return null;
  const from = (meta.page - 1) * meta.limit + 1;
  const to = Math.min(meta.page * meta.limit, meta.total);
  return (
    <div className="card-body border-t flex items-center justify-between">
      <span className="text-sm text-gray-500">
        {t('common.showing')} {from}-{to} {t('common.of')} {meta.total}
      </span>
      <div className="flex gap-1">
        <button
          className="btn btn-secondary btn-sm"
          disabled={meta.page <= 1}
          onClick={() => onPageChange(meta.page - 1)}
        >
          ←
        </button>
        <span className="px-3 py-1 text-sm text-gray-600">
          {meta.page} / {meta.pages}
        </span>
        <button
          className="btn btn-secondary btn-sm"
          disabled={meta.page >= meta.pages}
          onClick={() => onPageChange(meta.page + 1)}
        >
          →
        </button>
      </div>
    </div>
  );
}
